import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import { useConsent } from '../../lib/ConsentProvider';
import { VENDORS } from '../../lib/vendors';

function getJurisdictionNotice(): string {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (tz.startsWith('Europe/') || tz.startsWith('Atlantic/') || tz.startsWith('Arctic/')) {
    return 'This notice is provided under GDPR (EU/EEA).';
  }
  if (tz === 'America/Los_Angeles') {
    return 'This notice is provided under CCPA (California).';
  }
  return 'Please review our privacy practices.';
}

export function ConsentBanner() {
  const { accepted, accept } = useConsent();

  return (
    <Dialog open={!accepted} disableEscapeKeyDown maxWidth="sm" fullWidth>
      <DialogTitle>We use third-party services</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          To use this service you must acknowledge our use of the following data processors. This is
          required — there is no opt-out.
        </Typography>
        <Box sx={{ maxHeight: 320, overflowY: 'auto' }}>
          <List disablePadding>
            {VENDORS.map((vendor) => (
              <ListItem
                key={vendor.name}
                disablePadding
                sx={{ flexDirection: 'column', alignItems: 'flex-start', mb: 1.5 }}
              >
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'wrap' }}>
                  <Typography variant="subtitle2">{vendor.name}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {vendor.packages.join(', ')}
                  </Typography>
                </Box>
                <Typography variant="caption" display="block">
                  Data processed: {vendor.dataProcessed}
                </Typography>
                <Typography variant="caption" display="block">
                  Regions: {vendor.regions}
                </Typography>
                <Link
                  href={vendor.privacyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="caption"
                >
                  Privacy policy
                </Link>
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>
      <DialogActions sx={{ flexDirection: 'column', alignItems: 'flex-start', gap: 1, px: 3, pb: 2 }}>
        <Typography variant="caption" color="text.secondary">
          {getJurisdictionNotice()}
        </Typography>
        <Button variant="contained" onClick={accept} fullWidth>
          I understand and accept
        </Button>
      </DialogActions>
    </Dialog>
  );
}
